module.exports = __webpack_public_path__ + "static/media/my-img.7217152a.jpeg";